import React from 'react';
import $ from 'jquery';
import {Redirect} from "react-router-dom";
import {TextInput, PQDLogo, Button, SmallLink, AlertBox, ModalContainer } from '../components/components.js';
import StringUtils from '../utils/stringutils.js';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggingIn : false,
      failed : false,
      code: '',
      loginData : {},
      email : '',
      password : '',
      forgotDisplayed: 0,
      tempPass: 0
    };

    this.handleInputUpdate = this.handleInputUpdate.bind(this);
    this.loginClick = this.loginClick.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.doForgotLogin = this.doForgotLogin.bind(this);
    this.resetForgotDisplayed = this.resetForgotDisplayed.bind(this);

  }

  loginClick() {
    if(!this.state.email || !this.state.password) return;

    this.setState({
      loggingIn : true
    });

    var comp = this;
    
    window._fiUser.LOGIN(this.state.email, this.state.password, (response) => {
      if(response.code === 200) {
        var wasTempPw = (Object.keys(response.data).indexOf('temp_password') >= 0) ? 1 : 0;
        window._fiUser.GET((res) => {
          var data = res.data;
          window._fiSponsor.GET_ALL((r) => {
            comp.setState({
              loginData : data,
              code: response.code, 
              failed: false, 
              tempPass: wasTempPw
            });
          });
        });
        
      }
      else {
        if(response.data.attempt_number) {
          response.detail += ' You have ' + (4 - response.data.attempt_number) + ' attempts left until lockout.';
        }

        if(response.detail === 'User not found.') {
          response.detail = 'Too many attempts. This account is temporarily locked.';
        }
        
        comp.setState({
          failed : response.detail,
          loggingIn : false
        });
      }
    });
  }

  loggedIn() {
    /*this.setState({
      loggingIn : true
    });

    var comp = this;

    window._fiUser.GET((res) => {
          var data = res.data;

          if(res.code > 300) {
            comp.setState({
              failed: true,
              code: res.code
            });
            return;
          }
          window._fiSponsor.GET_ALL((r) => {
            comp.setState({
              loginData : data,
              code: res.code, 
              failed: false, 
              tempPass: 0
            });
          });
        });*/
  }

  forgotPassword() {
    this.setState({forgotDisplayed: 1});
  }

  doForgotLogin() {
    const component = this;
    window._fiUser.resetPassword($('[dataid="reset-email"]').val(), () => component.setState({forgotDisplayed : 2}));
  }

  resetForgotDisplayed() {
    this.setState({forgotDisplayed : 0})
  }

  handleInputUpdate(value, dataId) {
    var stateObj = {};
    stateObj[dataId] = value;
    this.setState(stateObj)
  }

  componentDidMount() {
    $('[dataid="password"]').keypress(function(e) { //If hit enter on password, click login.
      if(e.originalEvent.which === 13) {
        $('[dataid="login"]').click();
      }
    });

    //console.log('mounted = true');
    window.app.page_finished = true;
  }

  render() {
    //console.log('render = false');
    window.app.page_finished = false;

    const logoSize = {
      width : '40vmin',
      height : 'auto'
    };

    /**if(window._fiUser.loadSessionInfo() && this.state.failed === false && Object.keys(this.state.loginData).length === 0 && this.state.loggingIn === false) {
      this.loggedIn();
    }

    var ssoError = (StringUtils.get_param('status') === 'failed') ? true : false;*/

    var alertType = (this.state.failed) ? 'Error' : (this.state.code === 200) ? 'Success' : '';
    var alertContent = (this.state.failed) ? this.state.failed : (this.state.code === 200) ? 'Login Successful!' : '';

    var modalShow = false,
        modalHeader = '',
        modalPrompt = '',
        modalCancel = false,
        modalCancelCB = this.resetForgotDisplayed,
        modalAffirmative = 'Okay',
        modalOnClick = this.resetForgotDisplayed;


    switch(this.state.forgotDisplayed) {
      case 1:
        modalPrompt = (
          <div className="ModalBody">{'Enter the email address for which you would like to reset your password.'}<br /><br />
          <TextInput class="App-TextInput" dataId="reset-email" placeholder="email" value={''} />
          </div>
        );
        modalShow = true;
        modalHeader = 'Reset password?';
        modalCancel = true;
        modalAffirmative = 'Reset';
        modalOnClick = this.doForgotLogin;
        break;
      case 2:
        modalPrompt = (
            <div className="ModalBody">{'An email has been sent with instructions on how to reset your password.'}</div>
        );
        modalShow = true;
        modalHeader = 'Reset complete';
        break;
      default:
        break;
    }


    var loggingAddon = (this.state.loggingIn) ? ( <div className="App-LoadLayer"><div className="App-Loader login"></div></div> ) : '';
    const render = ( //If we haven't yet logged in, we're going to render the page
      <div className="Login">
        <div className="Login-Body">
          {loggingAddon}
          <PQDLogo class="Login-Logo" size={logoSize} />
          <div className="Login-Label">Login</div>
          <div className="Login-Content">
            <ModalContainer key="TheModal" size={{width: '50vmin', height : '40vmin'}} visible={modalShow} header={modalHeader} prompt={modalPrompt} cancelShown={modalCancel} cancelCallback={modalCancelCB} affirmativeLabel={modalAffirmative} onClick={modalOnClick} />
            <div className="Login-Constrictor">
              <AlertBox type={alertType} content={alertContent} />
              <TextInput class="App-TextInput" dataId="email" handleChange={this.handleInputUpdate} placeholder="email" value={this.state.email} />
              <TextInput class="App-TextInput" dataId="password" handleChange={this.handleInputUpdate} placeholder="password" value={this.state.password} type="password" />
              <Button class="App-Button" dataId="login" label="Login" onClick={this.loginClick} />
              <div className="Login-SmallLinks">
                <SmallLink class="App-Left" label="Trouble logging in?" onClick={() => {
                    const emailTo = 'support@plinqit.com';
                    const emailSub = 'Plinqit Dashboard Trouble Logging In';
                    const emailBody = 'How can we help you?';

                    window.location.href = "mailto:"+emailTo+'?subject='+emailSub+'&body='+emailBody;
                  }
                } />
                <SmallLink class="App-Right" label="Forgot Password" onClick={this.forgotPassword} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    //console.log("temp pass: " + this.state.tempPass);
    if(this.state.loggingIn && Object.entries(this.state.loginData).length > 0 && this.state.failed === false && this.state.tempPass === 0) {
      const redirect = (<Redirect to='/Home' />); //Otherwise we will render the redirect to Home.
      return redirect;
    }
    else if(this.state.loggingIn && Object.entries(this.state.loginData).length > 0 && this.state.failed === false && this.state.tempPass === 1) {
      return (<Redirect to='/PassReset' />); //If it was a temp password we go to password reset.
    }

    return render; 
  }
}


export default Login;



